// extracted by mini-css-extract-plugin
export default {"page-container":"styles_page-container__-goN6","content-container":"styles_content-container__rPm2V","hrline":"styles_hrline__ZRK6g","vrgap":"styles_vrgap__J0T6W"};